import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { useMaterialUIController } from "context";
import { useUpgrade, PLANS, PREMIUM_BENEFITS } from "context/upgrade";

// Modal global de upgrade. Aberto pelo clique em item com cadeado ou por 403 premium_required.
function UpgradeModal() {
  const { open, closeUpgrade, startCheckout, pendingAction } = useUpgrade();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const busy = Boolean(pendingAction);

  return (
    // disableEnforceFocus: sem isso o focus trap do MUI prende o foco e os alertas do Swal
    // abertos por cima (ex.: erro no checkout) não recebem teclado
    <Dialog open={open} onClose={busy ? undefined : closeUpgrade} fullWidth maxWidth="xs" disableEnforceFocus>
      <DialogContent>
        <MDBox position="relative" textAlign="center" pt={1}>
          <MDBox position="absolute" top={-8} right={-8}>
            <MDButton iconOnly variant="text" color="secondary" onClick={closeUpgrade} disabled={busy} aria-label="Fechar">
              <Icon>close</Icon>
            </MDButton>
          </MDBox>
          <Icon color="warning" sx={{ fontSize: "3rem !important" }}>workspace_premium</Icon>
          <MDTypography variant="h4" fontWeight="medium" mt={1}>
            Seja Premium
          </MDTypography>
          <MDTypography variant="button" color="text">
            Tudo o que você precisa para fechar mais festas.
          </MDTypography>
        </MDBox>

        <MDBox component="ul" sx={{ listStyle: "none", p: 0, my: 3 }}>
          {PREMIUM_BENEFITS.map((benefit) => (
            <MDBox component="li" key={benefit} display="flex" alignItems="center" mb={1}>
              <Icon color="success" fontSize="small" sx={{ mr: 1 }}>check_circle</Icon>
              <MDTypography variant="button" color="text">{benefit}</MDTypography>
            </MDBox>
          ))}
        </MDBox>

        <MDBox display="flex" flexDirection="column" gap={1.5}>
          <MDButton
            variant="gradient"
            color={sidenavColor}
            fullWidth
            disabled={busy}
            onClick={() => startCheckout("monthly")}
          >
            {pendingAction === "monthly"
              ? "Redirecionando..."
              : `${PLANS.monthly.label} ${PLANS.monthly.price}${PLANS.monthly.period}`}
          </MDButton>
          <MDButton
            variant="outlined"
            color={sidenavColor}
            fullWidth
            disabled={busy}
            onClick={() => startCheckout("yearly")}
          >
            {pendingAction === "yearly" ? "Redirecionando..." : `${PLANS.yearly.label} (${PLANS.yearly.price})`}
          </MDButton>
          <MDTypography variant="caption" color="text" textAlign="center">
            Pagamento seguro pelo Stripe. Cancele quando quiser.
          </MDTypography>
        </MDBox>
      </DialogContent>
    </Dialog>
  );
}

export default UpgradeModal;
